import React from 'react';
import { COST_CENTERS_VIEWS } from '../consts';
import { useCostCentersContext } from './contexts/costCentersContext';
import Spinner from 'shared/components/andtComponents/Spinner';
import CostCentersTreeView from 'users/containers/Organization/CostCenters/CostCentersViews/CostCentersTreeView';
import CostCentersTableView from 'users/containers/Organization/CostCenters/CostCentersViews/CostCentersTableView';

import styles from './CostCenterTable.module.scss';

const CostCentersTable = ({
  accountsData,
  costCenters,
  isCreateEditMode,
  isLoading,
  isSelectionEnabled,
  isRoleDataAccessView = false,
  onSelectionChange,
  noCostCentersInOrg,
}) => {
  const { costCentersView } = useCostCentersContext();

  return isLoading ? (
    <div className={styles.spinnerContainer}>
      <Spinner />
    </div>
  ) : (
    costCenters && (
      <>
        {costCentersView.id === COST_CENTERS_VIEWS.TREE.id ? (
          <CostCentersTreeView
            accountsData={accountsData}
            costCenters={costCenters}
            isRoleDataAccessView={isRoleDataAccessView}
            isCreateEditMode={isCreateEditMode}
            isSelectionEnabled={isSelectionEnabled}
            onSelectionChange={onSelectionChange}
            noCostCentersInOrg={noCostCentersInOrg}
          />
        ) : (
          <CostCentersTableView
            accountsData={accountsData}
            costCenters={costCenters}
            isRoleDataAccessView={isRoleDataAccessView}
            isCreateEditMode={isCreateEditMode}
            isSelectionEnabled={isSelectionEnabled}
            onSelectionChange={onSelectionChange}
            noCostCentersInOrg={noCostCentersInOrg}
          />
        )}
      </>
    )
  );
};


export default CostCentersTable;
